import React from 'react';
import {
  FUNDING_COMMISSION_STATUSES,
  FUNDING_DEAL_STAGES,
  FUNDING_LENDER_TYPES,
  FUNDING_PRODUCT_TYPES,
  FUNDING_READINESS_TIERS,
} from '../../utils/funding/constants';

const selectClass = 'rounded-xl border border-[var(--fg-line)] bg-white px-3 py-2 text-sm dark:bg-slate-950/20';

const FundingReportFilters = ({
  dateFrom,
  dateTo,
  status,
  lenderType,
  productType,
  assignedUserId,
  readinessTier,
  commissionStatus,
  stage,
  showReadinessTier,
  showCommissionStatus,
  showStage,
  onDateFromChange,
  onDateToChange,
  onStatusChange,
  onLenderTypeChange,
  onProductTypeChange,
  onAssignedUserChange,
  onReadinessTierChange,
  onCommissionStatusChange,
  onStageChange,
}) => (
  <div className="grid gap-3 md:grid-cols-2 xl:grid-cols-4">
    <input type="date" value={dateFrom} onChange={(e) => onDateFromChange(e.target.value)} className={selectClass} />
    <input type="date" value={dateTo} onChange={(e) => onDateToChange(e.target.value)} className={selectClass} />
    <select value={lenderType} onChange={(e) => onLenderTypeChange(e.target.value)} className={selectClass}>
      <option value="">All lender types</option>
      {FUNDING_LENDER_TYPES.map((item) => <option key={item} value={item}>{item}</option>)}
    </select>
    <select value={productType} onChange={(e) => onProductTypeChange(e.target.value)} className={selectClass}>
      <option value="">All products</option>
      {FUNDING_PRODUCT_TYPES.map((item) => <option key={item} value={item}>{item}</option>)}
    </select>
    <input
      type="text"
      value={assignedUserId}
      onChange={(e) => onAssignedUserChange(e.target.value)}
      placeholder="Assigned user ID"
      className={selectClass}
    />
    {showReadinessTier ? (
      <select value={readinessTier} onChange={(e) => onReadinessTierChange(e.target.value)} className={selectClass}>
        <option value="">All readiness tiers</option>
        {FUNDING_READINESS_TIERS.map((item) => <option key={item} value={item}>{item}</option>)}
      </select>
    ) : null}
    {showCommissionStatus ? (
      <select value={commissionStatus} onChange={(e) => onCommissionStatusChange(e.target.value)} className={selectClass}>
        <option value="">All commission statuses</option>
        {FUNDING_COMMISSION_STATUSES.map((item) => <option key={item} value={item}>{item}</option>)}
      </select>
    ) : null}
    {showStage ? (
      <select value={stage} onChange={(e) => onStageChange(e.target.value)} className={selectClass}>
        <option value="">All deal stages</option>
        {FUNDING_DEAL_STAGES.map((item) => <option key={item} value={item}>{item}</option>)}
      </select>
    ) : null}
    <select value={status} onChange={(e) => onStatusChange(e.target.value)} className={selectClass}>
      <option value="">All statuses</option>
      <option value="Funded">Funded</option>
      <option value="Approved">Approved</option>
      <option value="Submitted">Submitted</option>
    </select>
  </div>
);

export default FundingReportFilters;
